<template>
    <div class="Location">
		<div class="topTexts">
			<h2>{{lang.signup.location.header}}</h2>
			<p class="littleAndBold">{{lang.signup.location.introText}}</p>
			<p class="spacingBeforeInputs littleAndBold pinIconContainer" v-html="lang.signup.location.introText2.replace('{0}', `<img class='pinIcon' src='${pinUrl}'>`)"></p>
		</div>

        <LocationSelector />

        <div class="nextPageControls">
            <Button class="onlyText" @click="$router.push('profile')">{{lang.signup.button.back}}</Button>
            <Button @click="$router.push('done')">{{lang.signup.button.finish}}</Button>
        </div>
    </div>
</template>

<script>
import Input from '../components/Input.vue'
import Button from '../components/Button.vue'
import Checkbox from '../components/Checkbox.vue'
import lang from '../lang'
import LocationSelector from '../components/LocationSelector.vue'

const pinUrl = require('../assets/map-location-selector-pin.png')

export default {
	name: 'Location',
	props: [],
	data: () => ({
		lang,
		pinUrl,
	}),
	computed: {
		acceptToTermsOfUse() {
			return this.$store.state.acceptToTermsOfUse
		},
	},
	methods: {},
	components: {
		Input,
		Button,
		Checkbox,
		LocationSelector,
	},
}
</script>

<style lang="stylus">
.Location .pinIconContainer > img {
	vertical-align: sub;
    height: 18px;
    margin: 0 2px;
    opacity: 0.7;
}
</style>

<style lang="stylus" scoped>
.Location {
	text-align: center;
}
.topTexts {
	max-width: 400px;
	text-align: left;
	margin: 0 auto;
}
</style>
